const state = {
  breadcrumb: [],     // 面包屑
  selectedMenu: [],    // 选中的菜单
  isLogin: false, // 是否登陆
  userInfo: {} // 用户信息
  // currentUserId: '' // 用户id
}

export default state
